/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown>, per: NonNullable<unknown> }} Measure_Explainer_RateInputs */

const en_measure_explainer_rate = /** @type {((inputs: Measure_Explainer_RateInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_RateInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_RateInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.amount} ${i?.per}`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_RateInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " " }, { type: "text", value: String(i?.per) }])
			})
		}
	)
);

const zh_hans1_measure_explainer_rate = /** @type {((inputs: Measure_Explainer_RateInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_RateInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_RateInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.per} ${i?.amount}`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_RateInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: String(i?.per) }, { type: "text", value: " " }, { type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }])
			})
		}
	)
);

const pt_br2_measure_explainer_rate = /** @type {((inputs: Measure_Explainer_RateInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_RateInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_RateInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.amount} ${i?.per}`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_RateInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " " }, { type: "text", value: String(i?.per) }])
			})
		}
	)
);

const es_measure_explainer_rate = /** @type {((inputs: Measure_Explainer_RateInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_RateInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_RateInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.amount} ${i?.per}`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_RateInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " " }, { type: "text", value: String(i?.per) }])
			})
		}
	)
);

const fr_measure_explainer_rate = /** @type {((inputs: Measure_Explainer_RateInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_RateInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_RateInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.amount} ${i?.per}`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_RateInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " " }, { type: "text", value: String(i?.per) }])
			})
		}
	)
);

const de_measure_explainer_rate = /** @type {((inputs: Measure_Explainer_RateInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_RateInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_RateInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.amount} ${i?.per}`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_RateInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " " }, { type: "text", value: String(i?.per) }])
			})
		}
	)
);

const ru_measure_explainer_rate = /** @type {((inputs: Measure_Explainer_RateInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_RateInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_RateInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.amount} ${i?.per}`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_RateInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " " }, { type: "text", value: String(i?.per) }])
			})
		}
	)
);

const it_measure_explainer_rate = /** @type {((inputs: Measure_Explainer_RateInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_RateInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_RateInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.amount} ${i?.per}`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_RateInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " " }, { type: "text", value: String(i?.per) }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "{amount} {per}" |
*
* @param {Measure_Explainer_RateInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_explainer_rate = /** @type {((inputs: Measure_Explainer_RateInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & { parts: (inputs: Measure_Explainer_RateInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Measure_Explainer_RateInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, { v: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_RateInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString} */ ((inputs, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh-Hans") return zh_hans1_measure_explainer_rate(inputs)
			if (locale === "pt-BR") return pt_br2_measure_explainer_rate(inputs)
			if (locale === "es") return es_measure_explainer_rate(inputs)
			if (locale === "fr") return fr_measure_explainer_rate(inputs)
			if (locale === "de") return de_measure_explainer_rate(inputs)
			if (locale === "ru") return ru_measure_explainer_rate(inputs)
			if (locale === "it") return it_measure_explainer_rate(inputs)
			return en_measure_explainer_rate(inputs)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_RateInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[]} */ ((inputs, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh-Hans") return typeof zh_hans1_measure_explainer_rate.parts === "function" ? zh_hans1_measure_explainer_rate.parts(inputs) : [{ type: "text", value: zh_hans1_measure_explainer_rate(inputs) }]
				if (locale === "pt-BR") return typeof pt_br2_measure_explainer_rate.parts === "function" ? pt_br2_measure_explainer_rate.parts(inputs) : [{ type: "text", value: pt_br2_measure_explainer_rate(inputs) }]
				if (locale === "es") return typeof es_measure_explainer_rate.parts === "function" ? es_measure_explainer_rate.parts(inputs) : [{ type: "text", value: es_measure_explainer_rate(inputs) }]
				if (locale === "fr") return typeof fr_measure_explainer_rate.parts === "function" ? fr_measure_explainer_rate.parts(inputs) : [{ type: "text", value: fr_measure_explainer_rate(inputs) }]
				if (locale === "de") return typeof de_measure_explainer_rate.parts === "function" ? de_measure_explainer_rate.parts(inputs) : [{ type: "text", value: de_measure_explainer_rate(inputs) }]
				if (locale === "ru") return typeof ru_measure_explainer_rate.parts === "function" ? ru_measure_explainer_rate.parts(inputs) : [{ type: "text", value: ru_measure_explainer_rate(inputs) }]
				if (locale === "it") return typeof it_measure_explainer_rate.parts === "function" ? it_measure_explainer_rate.parts(inputs) : [{ type: "text", value: it_measure_explainer_rate(inputs) }]
				return typeof en_measure_explainer_rate.parts === "function" ? en_measure_explainer_rate.parts(inputs) : [{ type: "text", value: en_measure_explainer_rate(inputs) }]
			})
		}
	)
);